<script>
  import { inertia } from '@inertiajs/svelte';
  import Icon from '@iconify/svelte';
  import AppLayout from '../../components/AppLayout.svelte';
  import Button from '../../components/ui/Button.svelte';

  let { code, title, message } = $props();
</script>

<AppLayout>
  <div class="flex flex-col items-center text-center py-16">
    <div class="text-5xl font-black text-primary-200 mb-4">{code}</div>
    <Icon icon="mdi:alert-circle-outline" class="text-4xl text-secondary-300 mb-4" />
    <h1 class="text-hierarchy-2 mb-2">{title}</h1>
    <p class="text-secondary-500 mb-8 max-w-sm">{message}</p>
    <Button href="/">Back to dashboard</Button>
  </div>
</AppLayout>
